<template>
  <div>
    <b-modal
      size="sm"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      ref="loading-modal"
    >
      <div class="w-100 text-center">
        <b-spinner variant="info" label="Spinning" />
      </div>
    </b-modal>
    <b-modal
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      ref="instruction-modal"
    >
      <div class="d-block">
        <b-carousel
          id="carousel-1"
          :interval="10000"
          controls
          indicators
          no-wrap
          background="white"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333"
        >
          <b-carousel-slide
            v-for="(image, iIndex) in images"
            :key="iIndex"
            :img-src="image.img"
            img-height="480"
            img-width="1024"
          >
            <h1 class="text-dark">
              Recuerda que estas instrucciones también están debajo de la tabla!
            </h1>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      ref="add-student-modal"
    >
      <b-container>
        <b-row>
          <b-col class="text-left"><h3>{{ studentMode === "edit" ? "Actualizar estudiante" : "Agregar estudiante" }}</h3></b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Nombre*"
              label-size="sm"
              label-class="font-weight-bold pt-0"
            >
              <b-form-input v-model="name" required size="sm" type="text" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Apellido*"
              label-size="sm"
              label-class="font-weight-bold pt-0"
            >
              <b-form-input v-model="lastName" required size="sm" type="text" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Rut*"
              label-size="sm"
              label-class="font-weight-bold pt-0"
            >
              <b-form-input
                v-model="rut"
                required
                lazy-formatter
                :formatter="formatter"
                size="sm"
                type="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Fecha de nacimiento"
              label-size="sm"
              label-class="font-weight-bold pt-0"
            >
              <b-form-input v-model="birth" size="sm" type="date" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Diagnóstico"
              label-size="sm"
              label-class="font-weight-bold pt-0"
            >
              <b-form-select v-model="diagnostic" size="sm">
                <b-form-select-option v-for="diagnosis in diagnosesList" :key="diagnosis[0]" :value="diagnosis[0]">
                  {{ diagnosis[1] }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button block pill variant="primary" @click="addEurekaStudent"
              > {{ studentMode === "edit" ? "Actualizar" : "Añadir" }} </b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-container v-if="mode === 'admin' && !studentGradeID">
      <b-row v-if="!$store.state.login.isPaid && schools.length" class="my-2 ">
        <b-col cols="1" class="text-right my-auto">Colegio:</b-col>
        <b-col cols="7" class="mx-0">
          <b-form-select v-model="school" @change="changeSchool" class="yellow-border-select">
            <b-form-select-option
              v-for="(sc, index) in schools"
              :key="index"
              :value="sc.id"
            >
              {{ sc.name }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col cols="1" class="text-right my-auto">
          Año:
        </b-col>
        <b-col cols="3" class="text-left">
          <b-form-select v-model="year" @change="changeYear" class="yellow-border-select">
            <b-form-select-option
              v-for="(yr, index) in years"
              :key="index"
              :value="yr"
            >
              {{ yr }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="!$store.state.login.isPaid && separatedLevels.length">
        <b-col class="special-col"><div class="pt-1 h-100">Nivel</div></b-col>
        <b-col
          v-for="(gr, grIndex) in separatedLevels[1].levels"
          :key="grIndex + '-gr'"
          class="mx-0 px-0 text-center"
          md="1"
          cols="2"
        >
          <b-button
            :variant="activeGrade === gr.code ? 'primary' : 'outline-primary'"
            class="mx-1"
            :class="activeGrade === gr.code ? 'text-white' : 'text-dark'"
            @click="changeActiveGrade(gr.code)"
          >
            <strong>{{ gr.name.split(" ")[0] }}</strong>
          </b-button>
          <!-- <b-button
            :variant="activeGrade === undefined ? 'primary' : 'outline-primary'"
            class="mx-1 text-dark"
            @click="activeGrade = undefined"
          >
            <strong>Extra</strong>
          </b-button> -->
        </b-col>
        <div
          v-for="(gr, grIndex) in separatedLevels[2].levels"
          :key="grIndex + '-grM'"
        >
          <b-col
            class="mx-0 px-0 text-center"
            md="1"
            cols="2"
            v-if="grades.filter((grade) => grade.grade === gr.code)[0]"
          >
            <b-button
              :variant="activeGrade === gr.code ? 'primary' : 'outline-primary'"
              class="mx-1"
              :class="activeGrade === gr.code ? 'text-white' : 'text-dark'"
              @click="changeActiveGrade(gr.code)"
            >
              <strong>{{ gr.name.split(" ")[0] }}M</strong>
            </b-button>
            <!-- <b-button
              :variant="activeGrade === undefined ? 'primary' : 'outline-primary'"
              class="mx-1 text-dark"
              @click="activeGrade = undefined"
            >
              <strong>Extra</strong>
            </b-button> -->
          </b-col>
        </div>
      </b-row>
      <div class="accordion" role="tablist">
        <h4
          class="text-center my-5 font-weight-bold"
          v-if="
            !$store.state.login.isPaid &&
            !activeGrade &&
            !grades.filter((grade) => {
              return grade.grade === activeGrade;
            }).length
          "
        >
          No hay cursos con estudiantes! Intenta cambiar de año o primero selecciona un nivel y crea tu primer estudiante!
        </h4>
        <h4
          class="text-center my-5 font-weight-bold"
          v-if="
            !$store.state.login.isPaid &&
            activeGrade &&
            !grades.filter((grade) => {
              return grade.grade === activeGrade;
            }).length
          "
        >
          Añade tu primer estudiante, dando clic en "Añadir +" para rendir Eureka en este curso
        </h4>
        <div v-if="$store.state.login.isPaid">
          <b-card
            no-body
            class="mb-1"
            v-for="(grade, gIndex) in grades.filter((grade) => {
              if (!$store.state.login.isPaid) {
                return grade.grade === activeGrade;
              } else {
                return true;
              }
            })"
            :key="gIndex + '-g'"
          >
            <b-card-header header-tag="header" class="text-left" role="tab">
              <b-button
                size="lg"
                block
                @click="
                  visible === grade.id ? (visible = '') : (visible = grade.id)
                "
                variant="primary"
                pill
                >{{
                  !$store.state.login.isPaid && separatedLevels.length
                    ? separatedLevels[1].levels.filter(
                        (gr) => gr.code === activeGrade
                      )[0].name
                    : grade.rename
                    ? grade.rename
                    : grade.name
                }}</b-button
              >
            </b-card-header>
            <b-collapse
              :id="'accordion-' + gIndex"
              :visible="grades.length === 1 || visible === grade.id"
              @show="getStudents(grade.id)"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-container v-if="!students[grade.id]">
                <b-row>
                  <b-col class="text-center">
                    <b-spinner
                      style="width: 3rem; height: 3rem"
                      type="grow"
                      label="Loading..."
                    ></b-spinner>
                  </b-col>
                </b-row>
              </b-container>
              <div v-else>
                <eureka-table-table
                  :grade="grade"
                  :year="year"
                  :download="download"
                  :levels="levels"
                  :students="students"
                  :tests="tests"
                  @get-students="getStudents"
                  @review="review"
                  @generate-report="generateReport"
                  @download-selected="downloadSelected"
                  @download-writing-template="downloadWritingTemplate"
                />
                <div
                  class="w-100 text-center my-4"
                  v-if="!students[grade.id] || !students[grade.id].length"
                >
                  <strong> No hay estudiantes para mostrar </strong>
                </div>
              </div>
            </b-collapse>
          </b-card>
        </div>
        <b-container v-if="!$store.state.login.isPaid" class="px-0">
          <b-row
            v-for="(grade, gIndex) in grades.filter((grade) => {
              if (!$store.state.login.isPaid) {
                return grade.grade === activeGrade;
              } else {
                return true;
              }
            })"
            :key="gIndex + '-g'"
          >
            <b-col class="text-center mx-0 px-0 w-100">
              <eureka-table-table
                :grade="grade"
                :year="year"
                :download="download"
                :levels="levels"
                :students="students"
                :tests="tests"
                @open-edit="openEdit"
                @get-students="getStudents"
                @review="review"
                @generate-report="generateReport"
                @download-selected="downloadSelected"
                @download-writing-template="downloadWritingTemplate"
              />
              <div
                class="w-100 text-center my-4"
                v-if="!students[grade.id] || !students[grade.id].length"
              >
                <strong> No hay estudiantes para mostrar </strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="special-col pt-2">
              Estudiantes: {{ currentStudents }}
            </b-col>
            <b-col>
              <b-button
                variant="outline-primary"
                block
                :disabled="!activeGrade"
                @click="
                  name = '';
                  lastName = '';
                  rut = '';
                  birth = '';
                  diagnostic = 0;
                  studentMode = 'add';
                  $refs['add-student-modal'].show();
                "
                class="text-dark font-weight-bold"
              >
                Añadir +
              </b-button>
            </b-col>
            <b-col class="special-col pt-2">
              <strong>Usos <br class="d-md-none d-block" />disponibles:</strong>
              {{ $store.state.login.eurekaUses }}</b-col
            >
            <b-col>
              <b-button
                variant="outline-primary"
                block
                class="text-dark font-weight-bold"
                @click="buyUses"
              >
                Adquirir usos!
              </b-button>
            </b-col>
          </b-row>
        </b-container>
        <!-- <b-card no-body class="mb-1" v-if="!$store.state.login.isPaid">
                    <b-card-header header-tag="header" class="text-left" role="tab">
                        <b-button block @click="grade={}; $refs['add-grade-modal'].show()" variant="secondary" pill>
                            Añadir Curso
                        </b-button>
                    </b-card-header>
                </b-card> -->
      </div>
    </b-container>
    <div v-if="studentGradeID && singleStudent.tests">
      <eureka-table-table
        :year="year"
        :download="download"
        :levels="levels"
        :singleStudent="singleStudent"
        :tests="tests"
      />
    </div>
    <div v-if="mode === 'review'">
      <test-response-review
        :reviewResponseID="reviewTest.id"
        :selectedLink="reviewTest"
        @back="backToAdmin"
      />
    </div>
    <!-- <div v-if="mode === 'new'">
      <b-container>
        <b-row>
          <b-col class="text-left">
            <h3>Con qué nivel trabajas usualmente?</h3>
          </b-col>
        </b-row>
        <b-row class="my-2">
          <b-col class="text-center">
            <h4>Enseñanza Básica</h4>
            <b-button
              v-for="(gr, grIndex) in separatedLevels[1].levels"
              :key="grIndex + '-gr'"
              pill
              variant="primary"
              class="mx-1"
              @click="createEurekaBasicSchool(gr.code)"
            >
              {{ gr.name.split(" ")[0] }}
            </b-button>
          </b-col>
          <b-col class="text-center">
            <h4>Enseñanza Media</h4>
            <b-button
              v-for="(gr, grIndex) in separatedLevels[2].levels"
              :key="grIndex + '-gr'"
              pill
              variant="primary"
              class="mx-1"
              @click="createEurekaBasicSchool(gr.code)"
            >
              {{ highNameChange[gr.name.split(" ")[0]] }}
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <div class="d-block w-100">
            Al seleccionar un curso crearemos para ti un colegio de prueba con 3
            estudiantes.<br />
          </div>
        </b-row>
      </b-container>
    </div> -->
    <div v-if="mode === 'loading'" class="text-center">
      <b-spinner variant="info" label="Spinning" />
    </div>
    <div v-if="mode === 'admin' && download">
      <div class="d-block" v-if="false">
        <b-carousel
          id="carousel-1"
          :interval="10000"
          controls
          indicators
          background="white"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333"
        >
          <b-carousel-slide
            v-for="(image, iIndex) in images"
            :key="iIndex"
            :img-src="image.img"
            img-height="480"
            img-width="1024"
          >
            <h1 class="text-dark"></h1>
          </b-carousel-slide>
        </b-carousel>
      </div>
      <!-- <div v-else class="d-block text-center">
        <b-img
          v-for="(image, iIndex) in images"
          :key="iIndex"
          :src="image.img"
          class="d-block"
          fluid-grow
        />
      </div> -->
    </div>
  </div>
</template>
<script>
import customTestService from "../../../services/customTestService";
import redpieService from "../../../services/redpieService";
import informationService from "../../../services/informationService";
import EurekaTableTable from "./EurekaTableTable";
import EurekaTableButton from "./EurekaTableButton";
import TestResponseReview from "../../custom-tests/miscellaneous/TestResponseReview";
import {
  remainingUses,
  isOutOfUses,
} from "@/components/botpie-assistant/serviceUses";

export default {
  components: {
    EurekaTableButton,
    TestResponseReview,
    EurekaTableTable,
  },
  props: {
    studentGradeID: {
      type: String,
      required: false,
    },
    context: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      tests: [],
      grades: [],
      students: {},
      levels: [],
      schools: [],
      years: [new Date().getFullYear(), new Date().getFullYear() - 1],
      year: this.$store.state.login.year ? this.$store.state.login.year : new Date().getFullYear(),
      school: this.$store.state.login.school,
      separatedLevels: [],
      highNameChange: {
        "1°": "I°",
        "2°": "II°",
        "3°": "III°",
        "4°": "IV°",
      },
      test: [],
      visible: "",
      mode: "admin",
      diagnostic: "",
      birth: "",
      diagnosesList: [],
      download: false,
      // addIcon: require("../../../assets/img/sales/add-user.svg"),
      reviewTest: null,
      eurekaLevel: null,
      activeGrade: null,
      name: "",
      lastName: "",
      rut: "",
      images: [
        {
          name: "Aplicar Eureka",
          img: require("../../../assets/img/eureka table sections/Front Eureka_4.png"),
        },
        {
          name: "Interrumpir una Evaluación",
          img: require("../../../assets/img/eureka table sections/Front Eureka_5.png"),
        },
        {
          name: "Corregir una Evaluación",
          img: require("../../../assets/img/eureka table sections/Front Eureka_6.png"),
        },
        {
          name: "Corregir una Evaluación",
          img: require("../../../assets/img/eureka table sections/Front Eureka_7.png"),
        },
        {
          name: "Generar Informe",
          img: require("../../../assets/img/eureka table sections/Front Eureka_8.png"),
        },
        {
          name: "Consideraciones especiales",
          img: require("../../../assets/img/eureka table sections/Front Eureka_9.png"),
        },
      ],
      singleStudent: {},
      studentMode: 'add',
    };
  },
  created() {
    this.getDiagnostics();
    this.getLevels();
    this.getTests();
    if (this.context && this.context.try && !this.$store.state.login.school) {
      this.createEurekaBasicSchool(this.context.try.code);
    }
    if (!this.$store.state.login.isPaid) {
      this.getSchools();
    }
    this.$socket.sendObj({
      type: "join_school",
      school_id: this.$store.state.login.school,
    });
    this.$options.sockets.onmessage = (data) => {
      const message = JSON.parse(data.data);
      if (message.type === "eureka_uses_update") {
        this.$store.commit("login/setEurekaUses", message.eureka_uses);
      }
    };
  },
  watch: {
    "$store.state.login.school"() {
      if (this.$store.state.login.school) {
        this.$socket.sendObj({
          type: "join_school",
          school_id: this.$store.state.login.school,
        });
      }
    },
  },
  computed: {
    currentStudents() {
      if (!this.$store.state.login.isPaid) {
        if (this.activeGrade) {
          let grade = this.grades.filter(
            (grade) => grade.grade === this.activeGrade
          )[0];
          if (grade) {
            if (this.students[grade.id]) {
              return this.students[grade.id].length;
            }
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      }
      return 0;
    },
  },
  methods: {
    changeYear() {
      this.$store.commit("login/setYear", this.year);
      this.getGrades();
    },
    openEdit(student) {
      this.name = student.student_first_name;
      this.lastName = student.student_last_name;
      this.rut = student.student_rut;
      this.birth = student.student_birth;
      this.diagnostic = student.diagnostic;
      this.studentMode = "edit";
      this.$refs['add-student-modal'].show();
    },
    changeSchool() {
      this.$socket.sendObj({
        type: "leave_school",
        school_id: this.$store.state.login.school,
      });
      redpieService.schoolSelected({ school: this.school });
      this.$store.commit("login/setSchool", this.school);
      this.$socket.sendObj({
        type: "join_school",
        school_id: this.$store.state.login.school,
      });
      let newEurekaUses = this.schools.filter(
        (sc) => sc.id === this.school
      )[0].eureka_uses;
      this.$store.commit("login/setEurekaUses", newEurekaUses);
      this.getGrades();
    },
    getSchools() {
      redpieService.getUserSchools().then((data) => {
        this.schools = data;
      });
    },
    buyUses() {
      window.location.href = "/utopie#/buy_product/eureka";
    },
    changeActiveGrade(gradeCode) {
      this.activeGrade = gradeCode;
      let grade = this.grades.filter(
        (grade) => grade.grade === this.activeGrade
      )[0];
      if (grade) {
        let gradeID = grade.id;
        this.getStudents(gradeID);
        this.visible = gradeID;
      }
    },
    addEurekaStudent() {
      if (!this.name || !this.lastName || !this.rut) {
        this.$toasted.error("Debes completar todos los campos.");
        return;
      }
      if (!this.birth) {
        this.birth = null;
      }
      customTestService
        .addEurekaStudent({
          name: this.name,
          last_name: this.lastName,
          rut: this.rut,
          birth: this.birth,
          diagnostic: this.diagnostic,
          grade: this.activeGrade,
          school: this.$store.state.login.school,
          year: this.year,
        })
        .then((data) => {
          this.$toasted.success(data.message);
          this.$refs["add-student-modal"].hide();
          this.getGrades();
          this.name = "";
          this.lastName = "";
          this.rut = "";
          this.birth = "";
          this.diagnostic = "";
        }).catch((error) => {
          let errorMessage = "Ha ocurrido un error, recarga el sitio e intenta nuevamente.";
          if (error.response && error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.message) {
            errorMessage = error.message;
          }
          this.$toasted.error(errorMessage);
        });
    },
    getDiagnostics() {
      informationService.getDiagnosesList().then((data) => {
        this.diagnosesList = data.diagnoses;
      });
    },
    getSingleData() {
      customTestService
        .getSingleStudentEurekaStatus(this.studentGradeID)
        .then((data) => {
          // this.$set(this.students, gradeID, data);
          this.singleStudent = data;
        });
    },
    startInNew() {
      this.mode = "new";
    },
    downloadSelected(selected, studentID, level) {
      if (selected === 0) {
        this.downloadWritingTemplate(level);
      }
      if (selected === 1) {
        this.downloadReport(studentID, level);
      }
      if (selected === 2) {
        this.downloadProtocol(studentID, level);
      }
      if (selected === 3) {
        this.downloadTemplate(studentID, level);
      }
    },
    generateLink(test) {
      customTestService
        .generateLink({
          test: test.test_id,
          rut: test.student_rut,
          email: test.student_email,
          name: test.student_name,
          videocall_kind: 3,
          student_grade: test.student_grade,
        })
        .then(
          (data) => {
            test.started = true;
            let testURL = `${process.env["VUE_APP_BASE_URL"]}/tests#/t/${data.id}`;
            window.open(testURL, "_blank").focus();
          },
          () => this.$toasted.error("Ocurrió un error. Intenta nuevamente.")
        );
    },
    goToTest(test) {
      if (test.started || test.id) {
        let testURL = `${process.env["VUE_APP_BASE_URL"]}/tests#/t/${test.id}`;
        window.open(testURL, "_blank").focus();
      } else {
        this.generateLink(test);
      }
    },
    getLevels() {
      informationService.getPieGrades().then((data) => {
        this.separatedLevels = data.grades_by_level;
        this.levels = data.grades.filter((grade) => grade[0] > 1);
      });
    },
    downloadWritingTemplate(level) {
      customTestService
        .downloadWritingTemplate({ level: level })
        .then((response) => {
          var filename = "";
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          var blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        });
    },
    getTests() {
      customTestService.getTests().then((data) => {
        this.tests = data.filter((test) => test.use_audio);
        if (!this.studentGradeID) {
          this.getGrades();
        } else {
          this.getSingleData();
        }
      });
    },
    getTest(tests, subject, level, student) {
      try {
        if (
          tests.length &&
          tests.filter(
            (test) => test.test_subject === subject && test.test_level === level
          ).length
        ) {
          return tests.filter(
            (test) => test.test_subject === subject && test.test_level === level
          )[0];
        } else {
          var test = this.tests.filter(
            (test) => test.subject === subject && test.level === level
          )[0];
          var d = {
            student_rut: student.student_rut,
            student_name: student.student_name,
            student_email: student.student_email,
            student_grade: student.id,
          };
          if (test) {
            d["test_id"] = test.id;
          }
          return d;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getGrades() {
      if (this.$store.state.login.school) {
        redpieService
          .getGradesByYear(
            this.year,
            this.$store.state.login.school
          )
          .then((data) => {
            this.grades = data.filter((grade) => grade.grade > 1);
            if (this.grades.length === 1) {
              this.getStudents(this.grades[0].id);
              this.visible = this.grades[0].id;
              if (!this.$store.state.login.isPaid) {
                this.activeGrade = this.grades[0].grade;
              }
            } else {
              if (this.activeGrade) {
                let gradeID = this.grades.filter(
                  (grade) => grade.grade === this.activeGrade
                )[0].id;
                this.getStudents(gradeID);
                this.visible = gradeID;
              } else {
                if (!this.$store.state.login.isPaid) {
                  this.grades.sort((a, b) => {
                    return a.grade - b.grade;
                  });
                  this.activeGrade = this.grades[0].grade;
                  let gradeID = this.grades.filter(
                    (grade) => grade.grade === this.activeGrade
                  )[0].id;
                  this.getStudents(gradeID);
                  this.visible = gradeID;
                }
              }
            }
            if (this.$store.state.login.isPaid) {
              this.download = false;
            } else {
              this.download = true;
            }
          });
      } else {
        this.mode = "loading";
      }
    },
    openInstructionModal() {
      this.$refs["instruction-modal"].show();
    },
    createEurekaBasicSchool(level) {
      this.mode = "loading";
      if (!level) {
        redpieService
          .createEurekaBasicSchool({ level: this.eurekaLevel })
          .then((data) => {
            this.$store.commit("login/setEurekaUses", data.eureka_uses);
            this.download = true;
            this.grades = [data];
            this.activeGrade = data.grade;
            this.mode = "admin";
            this.$store.commit("login/setSchool", data.school);
            // this.openInstructionModal();
            this.getStudents(data.id);
            this.visible = data.id;
          });
      } else {
        redpieService.createEurekaBasicSchool({ level: level }).then((data) => {
          this.$store.commit("login/setEurekaUses", data.eureka_uses);
          this.download = true;
          this.grades = [data];
          this.activeGrade = data.grade;
          this.mode = "admin";
          this.$store.commit("login/setSchool", data.school);
          // this.openInstructionModal();
          this.getStudents(data.id);
          this.visible = data.id;
        });
      }
    },
    downloadReport(sgID, level) {
      this.openLoading();
      customTestService
        .downloadEurekaReport({ student_grade: sgID, level: level })
        .then((response) => {
          var filename = "";
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          var blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          this.closeLoading();
        });
    },
    downloadProtocol(sgID, level) {
      this.openLoading();
      customTestService
        .downloadEurekaProtocol({ student_grade: sgID, level: level })
        .then((response) => {
          var filename = "";
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          var blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          this.closeLoading();
        });
    },
    downloadTemplate(sgID, level) {
      customTestService
        .downloadEurekaTemplate({ student_grade: sgID, level: level })
        .then((response) => {
          var filename = "";
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          var blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        });
    },
    openLoading() {
      this.$refs["loading-modal"].show();
    },
    closeLoading() {
      this.$refs["loading-modal"].hide();
    },
    getStudents(gradeID) {
      customTestService.getStudentsEurekaStatus(gradeID).then((data) => {
        this.$set(this.students, gradeID, data);
      });
    },
    // Closing a review costs 1 Eureka use, except for the student's first one
    // (the backend only charges when they already have a reviewed evaluation).
    reviewCosts(test) {
      const student = Object.values(this.students)
        .flat()
        .find((s) => (s.tests || []).some((t) => t.id === test.id));
      return !!student && student.tests.some((t) => t.reviewed);
    },
    review(test) {
      // Warned here and not on "Guardar y cerrar": failing at save time would
      // throw away a review the user already filled in. Same threshold the chat
      // menu highlights on, and a null balance (paid / unknown) never blocks.
      if (isOutOfUses(remainingUses("eureka")) && this.reviewCosts(test)) {
        this.handleNoUses();
        return;
      }
      this.reviewTest = test;
      this.mode = "review";
    },
    // Out of uses: the review can't be closed, so don't let it be started.
    async handleNoUses() {
      await this.$bvModal.msgBoxOk(
        "Revisar y cerrar esta evaluación cuesta 1 uso de Eureka y no te quedan usos disponibles. Puedes conseguir más comprando, completando misiones o agendando una reunión con nosotros.",
        {
          title: "¡Te quedaste sin usos!",
          okTitle: "Ver cómo conseguir usos",
          okVariant: "primary",
          centered: true,
        }
      );
      // The chat menu already highlights the three ways to get uses once the
      // balance hits 0 (serviceUses.usesCardClass), so just send the user back
      // to it. ponytail: standalone table has no chat — fall back to the buy
      // modal, which is what this path did before.
      if (this.$listeners["go-to-step"]) {
        this.$emit("go-to-step", "mainMessage");
      } else {
        this.$store.commit("login/openEurekaModal");
      }
    },
    backToAdmin() {
      this.getStudents(this.visible);
      if (this.context && this.context.service) {
        window.scrollTo(0, 1000);
      } else {
        window.scrollTo(0, 0);
      }
      this.reviewTest = null;
      this.mode = "admin";
    },
    generateReport(sgID, level) {
      customTestService
        .createReport({ student_grade: sgID, level: level })
        .then(() => {
          this.$toasted.success("Informes generados!");
        });
    },
    validate() {
      if (typeof this.rut !== "string") {
        this.state = false;
        return;
      }
      if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(this.rut)) {
        this.state = false;
        this.invalidMessage = "El formato no coincide con el esperado";
        return;
      }
      let clean = this.rut.replace(/[^\w\s]|_/g, "");
      clean = clean.slice(0, clean.length - 1);
      let t = parseInt(clean, 10);
      let m = 0;
      let s = 1;

      while (t > 0) {
        s = (s + (t % 10) * (9 - (m++ % 6))) % 11;
        t = Math.floor(t / 10);
      }

      let v = s > 0 ? "" + (s - 1) : "K";
      this.state = v === this.rut.slice(-1);
      if (!this.state)
        this.invalidMessage = "El dígito verificador no corresponde al RUT";
    },
    formatter() {
      this.rut = this.rut.toUpperCase();
      this.rut = this.rut.replace(" ", "").replace(/\./g, "").replace(/-/g, "");
      let result = "";
      if (this.rut.length === 9) {
        if (this.rut.charAt(this.rut.length - 2) !== "-")
          result = [
            this.rut.slice(0, this.rut.length - 1),
            "-",
            this.rut.slice(this.rut.length - 1),
          ].join("");
        else result = this.rut;
        if (result.charAt(2) !== ".")
          result = [result.slice(0, 2), ".", result.slice(2)].join("");
        if (result.charAt(6) !== ".")
          result = [result.slice(0, 6), ".", result.slice(6)].join("");
      } else if (this.rut.length === 8) {
        if (this.rut.charAt(this.rut.length - 2) !== "-")
          result = [
            this.rut.slice(0, this.rut.length - 1),
            "-",
            this.rut.slice(this.rut.length - 1),
          ].join("");
        else result = this.rut;
        if (result.charAt(1) !== ".")
          result = [result.slice(0, 1), ".", result.slice(1)].join("");
        if (result.charAt(5) !== ".")
          result = [result.slice(0, 5), ".", result.slice(5)].join("");
      } else if (this.rut.length === 10) {
        if (this.rut.charAt(this.rut.length - 2) !== "-")
          result = [
            this.rut.slice(0, this.rut.length - 1),
            "-",
            this.rut.slice(this.rut.length - 1),
          ].join("");
        else result = this.rut;
        if (result.charAt(3) !== ".")
          result = [result.slice(0, 3), ".", result.slice(3)].join("");
        if (result.charAt(7) !== ".")
          result = [result.slice(0, 7), ".", result.slice(7)].join("");
      }
      this.validate();
      if (!this.state) {
        this.rut = "";
        return "";
      }
      this.rut = result;
      return result;
    },
  },
};
</script>
<style lang="scss">
.special-col {
  color: rgb(0, 0, 0);
  border: 1pt dashed $primary;
  border-radius: 8px;
  font-family: "Ubuntu";
  max-width: 80%;
}
.special-row {
  color: rgb(0, 0, 0);
  border: 1pt dashed $primary;
  border-radius: 8px;
  font-family: "Ubuntu";
}
.value-container {
  cursor: pointer;
  margin: 0 auto;
  width: 56px;
  height: 24px;
  background-color: white;
  border: solid 1px;
  border-radius: 16px;
  font-size: 0.5em !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.plan-table {
  border: 2px solid $primary !important;
  border-radius: 8px;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
}
.yellow-border-select {
  border: 2px solid $primary !important;
  border-radius: 4px;
}
</style>
